import { render, staticRenderFns } from "./userstorageconfig-add.vue?vue&type=template&id=7f55cf87&"
import script from "./userstorageconfig-add.vue?vue&type=script&lang=ts&"
export * from "./userstorageconfig-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports